import { EChatActionTypes } from 'shared/actions/chat';
import { IAppState, TActions } from 'shared/common/state';

// TODO: Удалить в CD-226143/CD-225150. Онбординги на месяц.
export function chatOnboardingReducer(state: IAppState, action: TActions): IAppState {
  switch (action.type) {
    case EChatActionTypes.Open:
    case EChatActionTypes.OpenAfterAuth:
    case EChatActionTypes.OpenNewbuildingChat:
    case EChatActionTypes.OpenNewbuildingChatAfterAuth:
      if (state.chatOnboarding) {
        return {
          ...state,
          chatOnboarding: {
            ...state.chatOnboarding,
            wasOfferChatOpened: true,
          },
        };
      }

      return state;
    default:
      return state;
  }
}
